

import { Component, Input, OnInit, AfterViewInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { URLS } from 'src/app/constants/URLS';
import { getVideoStreamFile } from 'src/app/utils/media-url.utils';
import { AppComponent } from '../../app.component';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MycontentserviceService } from 'src/app/_service/mycontentservice.service';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { DownloadProgressService } from 'src/app/_service/download-progress.service';


declare let shaka: any | undefined;
declare var window: any | undefined;



@Component({
  selector: 'app-thumbnail-view',
  templateUrl: './thumbnail-view.component.html',
  styleUrls: ['./thumbnail-view.component.css']
})
export class ThumbnailViewComponent implements OnInit {
  @Input() items = [];
  @Input() downloadView: boolean = false;
  @Input() donwloadButton: boolean = false;
  @Input() WatchListButton: boolean = false;
  @Input() showCarousel: boolean = false;
  @Input() watchListView: boolean = false;
  @Input() id = Math.random();
  @Input() setToptoZero = false;


  mediaUrl: String = URLS.BASE_URL + '/static/post_videos/';


  appComponent;


  //ui changes
  popUpBool: boolean = false;
  selectedCotegoryContent: any;
  progressBarPer = 0;
  progressBarId = '';
  downloadingToast = false;
  downloadToastText = '';
  loaderShowHide = true;
  isDownloadedText = false;
  isLoading: boolean = false;
  downloadedData = [];
  @ViewChild('video') video: ElementRef | undefined;
  isVideoPlayerOpened: boolean = false;
  userId: string;
  donwloadInprogress: boolean = false;


  positon: any =
    {
      top: "0px",
      left: "0px",
      width: "0px",
    }
  watchList: any;
  scrolledItemsCount: any;
  AddButtonCSSStyles() {
    return this.positon;
  };


  constructor(public router: Router, private mycontentService: MycontentserviceService, private toaster: ToastrService, private downloadProgressService: DownloadProgressService) { }
  ngOnInit(): void {
    for(const item of this.items) {
      if(item.channelId) {
        // this.mycontentService.getImageBlob(URLS.channelIconBaseUrl + item.channelId + URLS.channelIconThumbUrl);
        item.channelIcon = URLS.channelIconBaseUrl + item.channelId + URLS.channelIconThumbUrl;
        item.preparedVideoType = this.prepareVideoType(item);
      }
    }

    // this.appComponent = new AppComponent(this.downloadProgressService);
    this.setDonwloadedVideos();
    console.log("items", this.items[0]);
    this.downloadProgressService.downloadCompletedEvent.subscribe((event) => {
      this.setDonwloadedVideos();
    });
  }
  prepareVideoType(category) {
    const channelData = JSON.parse(localStorage.getItem('channelData'));
    let isChannelSubscribed = false;
    if(channelData) {
      for( const channel of channelData) {
        if(channel.channelId == category.channelId){
          isChannelSubscribed = channel.isSubscribed == 'true';
          break;
        }
      }
    }
      if(category.isFreeVideo) {
        return 'FREE';
      } else if(isChannelSubscribed && category.sub_value && category.sub_value != '0'){
        return category.sub_value;
      } else if(!isChannelSubscribed && category.unSub_value && category.unSub_value != '0'){
        return category.unSub_value;
      } else {
        return 'Sub';
      }
    }

  async setDonwloadedVideos() {
    const content = await this.listContent();
    for (const category of this.items) {
      category.imageUrl =this.fetchImageUrl(category.thumbnail);
      for (const ele of content) {
        if (ele && ele.originalManifestUri.includes(category.vidLibId)) {
          category.isDownloaded = true;
        }
      }
    }
  }
  async fetchImageUrl(imgUrl) {
    const url = this.downloadView ? imgUrl : `${this.mediaUrl}${imgUrl}`;
    return this.mycontentService.getImageBlob(url);
  }
  listContent() {
    return window.storage.list()
  }


  playContent(content) {
    window.player.load(content.offlineUri);
  }


  removeContent(content) {
    return window.storage.remove(content.offlineUri);
  }


  downloadContent(manifestUri, title) {
    const metadata = {
      'title': title,
      'downloaded': Date(),
      'fileSize': this.selectedCotegoryContent.videoFileSize,
      categoryId: this.selectedCotegoryContent.categoryId,
      vidLibId: this.selectedCotegoryContent.vidLibId,
      ...this.selectedCotegoryContent
    };

    const downloadProgress = window.storage.store(manifestUri, metadata);
    downloadProgress.chain( (storedContent)=> {
      console.log("on downloadSuccess", storedContent);
      storedContent.isCompleted = true;
      this.downloadProgressService.prepareDownloadData(storedContent);
    }, (err) => {
      console.log("we got error while storing", err);
    })
    
  }

  onDownloadClick(manifestUri: string) {
    console.log("manifestUri:" + manifestUri);
    const title = 'test';
    console.log("title:" + title)
    // this.appComponent.setDownloadProgress(null, 0);
    this.downloadContent(manifestUri, title)
    //  .then(()=> {
    //    return this.refreshContentList();
    //  })
    //  .then((content) =>{
    //    console.log("then method inside download")
    //    this.setDownloadProgress(null, 1);
    //   //  this.toastr.success("successfully downloaded");
    //   //  downloadButton.disabled = false;
    //  })
    //  .catch((error) =>{
    //    // In the case of an error, re-enable the download button so
    //    // that the user can try to download another item.
    //   //  downloadButton.disabled = false;
    //   //  this.toastr.error("downloadig failed..")
    //    this.onError(error);
    //  });
  }

  updateOnlineStatus() {
    const signal = document.getElementById('online-signal');
    if (navigator.onLine) {
      signal.innerHTML = 'ONLINE';
      signal.style.background = 'green';
    } else {
      signal.innerHTML = 'OFFLINE';
      signal.style.background = 'grey';
    }
  }

  async donwloadCompleted(manifestUri) {
    this.loaderShowHide = false;
    this.downloadingToast = false;
    this.downloadedData = await this.listContent();
    let offlineUri = '';
    for (const content of this.downloadedData) {
      console.log("insinide offlineUri check ", content.originalManifestUri, manifestUri);

      if (content.originalManifestUri === manifestUri) {
        offlineUri = content.offlineUri;
        break;
      }
    }
    console.log("url matched", offlineUri)
    this.router.navigate([]).then(result => { window.open(`/#/tqr/shaka-player?offlineUri=${offlineUri}`, '_blank'); });
  }

  async isDownloadFIleExist(originalManifestUri) {
    let isExist = false;
    const content = await this.listContent();
    for (const video of (content || [])) {
      if (video.originalManifestUri.includes(originalManifestUri)) {
        isExist = true;
      }
    }
    return isExist;
  }

  Cool(event: any, item: any) {
    const containerFluidELe = document.querySelectorAll('.container-fluid');
    for(let i = 0; i< containerFluidELe.length; i++) {
      containerFluidELe[i]['style'].minHeight = '220vh'
    }

    this.mycontentService.setPopUpList(this);
    this.popUpBool = true;
    this.selectedCotegoryContent = item;//"https://cdn.gulte.com/wp-content/uploads/2022/07/thank-1.jpg";//this.thumbNail.filter((x: { tn: any; })=> x.tn == event.target.src)[0];
    console.log("selectedCotegoryContent: ", this.selectedCotegoryContent);
    item.properties.forEach(i => {
      if (i.name == "channel") {
        this.selectedCotegoryContent.channel = i.value;
      }
    })

    console.log("event", event.target);
    let targetX = event.target.getBoundingClientRect().x;
    let targetY = event.target.getBoundingClientRect().y;
    if(targetX <= 150) {
      console.log(targetX);
      targetX = 0;
      targetY -= 10;
    } else if(targetX >= 1000) {
      targetX -= 140;
      targetY -= 10;
    } else {
      targetX -= 50;
      targetY -= 10;
      if(!this.showCarousel){
        targetX -= 75;
      }
    }
    if(!this.showCarousel) {
      this.positon.left =( window.scrollX + targetX ) + 'px';
      this.positon.top = this.setToptoZero ? '30px'  : ( window.scrollY + targetY - 130) + 'px';
    } 
    else {
      this.positon.left = window.scrollX + targetX + 'px';
      this.positon.top = '0px'
    }
    const ele = document.getElementById("thumbSlide") as HTMLElement;

    this.positon.width = (event.target.className === 'thumb-img' ? ele.getBoundingClientRect().width : event.target.getBoundingClientRect().width) + 150 +'px';
    console.log("poitions", this.positon, ele.offsetWidth);
  }



  @HostListener('document:click', ['$event'])
  Hot(event: any) {
    if (event.target.className !== 'thumb-img' && event.target.className !== 'background-img') {
      this.popUpBool = false;
      const containerFluidELe = document.querySelectorAll('.container-fluid');
    for(let i = 0; i< containerFluidELe.length; i++) {
      containerFluidELe[i]['style'].height = 'auto'
    }
    }
  }

  formatWatchSeconds(input: string) {
    return Math.floor(Number(input));
  }

  getStreamFile(videoOrId: any, suffix: string = '_drm_meta.mpd'): string {
    return getVideoStreamFile(videoOrId, suffix);
  }

  async downloadFile(fileUrl, videoId) {
    this.downloadProgressService.resetDownloadItems();
    this.isVideoPlayerOpened = false;
    this.progressBarId = videoId;
    this.downloadingToast = false;
    this.loaderShowHide = true;
    this.donwloadInprogress = true;
    this.downloadProgressService.currentDownloadVideoId = videoId;
    this.downloadProgressService.isDownloadInprogress = true;
    this.onDownloadClick(this.mediaUrl + fileUrl);
  }

  handleWatchList(selectedCotegoryContent) {
    if (selectedCotegoryContent.isEnable || this.watchListView) {
      this.removeFromWatchList(selectedCotegoryContent.vidLibId)
    } else {
      this.addInWatchList(selectedCotegoryContent.vidLibId)
    }
  }

  addInWatchList(vidLibId) {
    var userId = localStorage.getItem("userId");
    this.mycontentService.addInWatchList(userId, vidLibId).subscribe(result => {
      console.log("after add watch list", result);
      if (result == 0) {
        this.mapwatchContent();
        this.toaster.success("successfully added to the watchlist..");
      } else if (result == 1) {
        console.log("else block");
        this.toaster.success("unable to add please try again..");
      }
    })
  }

  banSli: OwlOptions = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    stagePadding: 0,
    pullDrag: true,
    dots: false,
    navSpeed: 100,
    nav: true,
    navText: ['<i class="fa fa-chevron-left"</i>', '<i class="fa fa-chevron-right"</i>'],
    responsive: {
      0: {
        items: 3,
        stagePadding: 0
      },
      400: {
        items: 4
      },
      740: {
        items: 8
      },
      940: {
        items: 8,
        stagePadding: 0
      }
    }
  };
  removeFromWatchList(vidLibId) {
    var userId = localStorage.getItem("userId");
    this.mycontentService.removeFromWatchList(userId, vidLibId).subscribe(result => { //126
      console.log("after remove watch list", result);
      if (result == 0) {
        this.mapwatchContent();
        this.toaster.success("successfully removed to the watchlist..");
      } else if (result == 1) {
        this.toaster.success("unable to remove please try again..");
      }
    })
  }

  transformData(data){
    for(const category of data){
      for(const prop of category.properties){
        switch(prop.name){
          case 'title': category.title = prop.value;
                        break;
          case 'files': const filesList = prop.value.split(',');
                        for(const file of filesList){
                          if(file.includes("thumb_v.jpg")){
                            category.vthumbnail = file;
                          }else if (file.includes(file.includes("thumb.jpg"))){
                            category.thumbnail = file;
                          }
                        }
                        break;
          case 'description': category.description = prop.value;
                        break;
          case 'duration': category.videoDuration = prop.value;
          category.durationInSeconds = this.convertToSeconds(category.videoDuration);
  
                        break;
                        case 'file_sizes': category.videoFileSize = this.findVideoFileSize(prop.value);
                        break;
                        case 'free_video': category.isFreeVideo = prop.value; break;
                        case 'channel': category.channelId = prop.value; break;
                          case 'category': category.genre = prop.value; break;
                          case 'pg_rating': category.rating = prop.value; break;
                          case 'starring': category.starring = prop.value; break;
                          case 'ppv_subscribed': category.sub_value = prop.value; break;
   case "ppv_unsubscribed": category.unSub_value = prop.value; break; 
   case 'size': const valueInMb = Math.floor((prop.value/1024)/1024);  category.videoSizeInMb = valueInMb + 'Mb';
                       }
      }
      category.preparedVideoType = this.prepareVideoType(category);
    }
  }
  convertToSeconds(time: string) {
    const splitTIme = time.split(":");
    return Number(splitTIme[0]) * 60 * 60 + Number(splitTIme[1]) * 60 + Number(splitTIme[2]);
  }

  findVideoFileSize(data: string) {
    const ele = data.split(',').find(item => item.includes('video.mp4'));
    if(ele){
      return ele.split("=")[1];
    }
    return 0;
  }
  mapwatchContent() {
    var usrId = localStorage.getItem("userId");
    this.mycontentService.getWatchListOfUser(usrId).subscribe(watchresult => { //need to dynamic it 126
      this.watchList = watchresult;
      if (this.watchListView) {
        this.items = this.watchList
      }
      this.transformData(this.items);
      this.mycontentService.watchListCount = this.watchList.length;
      this.items.forEach(category => {
        category.isEnable = false;
        this.watchList.forEach(wlitem => {
          if (category.vidLibId == wlitem.vidLibId) {
            category.isEnable = true;
          }
        })
      })
    });
  }
  onVideoClick(item) {
    this.router.navigate(['/tqr/shaka-player'], {queryParams: {offlineUri: item.offlineUri}});
  }

  ngOnDestroy() {
    // this.downloadProgressService.isDownloadInprogress = false;
  }

   async deleteDownloadedVideos(item, event) {
    console.log("items", item)
    event.stopPropagation();
    this.removeContent(item).then( res => {
      console.log("delete video succeessfully", res)
      
    }).catch( err=> {
      console.log("error while deleting downloadVideo", err);
    })
    this.items = this.items.filter( ele => ele.offlineUri !== item.offlineUri);
    this.mycontentService.downloadedCount = this.items.length;
  }
  onNavClick(event) {
    console.log("event revieved clicked on navs", event);
    const ele = document.getElementById('reached-alert-div'+this.id);
    if(event.startPosition == 13 && event.startPosition > this.scrolledItemsCount) {
      
      ele.style.display = 'block';
      setTimeout( ()=> {
        ele.style.display = 'none';
      }, 5000)
    } else {
    }
    this.scrolledItemsCount = event.startPosition;
  }

  showPopupFlag = false;
  selectedItem: any;

  showPopup(item: any) {
    this.selectedItem = item;
    this.showPopupFlag = true;
  }

  hidePopup() {
    this.showPopupFlag = false;
  }
}


